import React from 'react';
import { useLayoutFooter } from '@/hooks/useLayoutFooter';

export const useLogic = () => {
  const [isOpenDataDialogOpen, setIsOpenDataDialogOpen] = React.useState(false);

  const footerElement = React.useRef<HTMLElement>(null);
  const { useFooterResizeEffect } = useLayoutFooter();

  useFooterResizeEffect(footerElement);

  const onClickOpenDataButton = () => {
    setIsOpenDataDialogOpen(true);
  };

  const handleCloseOpenDataDialog = () => {
    setIsOpenDataDialogOpen(false);
  };

  return {
    footerElement,
    isOpenDataDialogOpen,
    onClickOpenDataButton,
    handleCloseOpenDataDialog,
  };
};
